module.exports = __webpack_public_path__ + "static/media/logo-fair-licensing-black_20201019_001.fa04b129.png";